import { gql, LazyQueryHookOptions, useLazyQuery } from "@apollo/client";
import {
  ProfessionFragment,
  PROFESSION_FRAGMENT,
} from "../../fragments/Profession";
import { ProfessionQueryVariables } from "../../types/queries";

export const GET_PROFESSIONS = gql`
  query getProfessions($q: String, $locale: String, $page: Int, $per: Int) {
    professions(q: $q, locale: $locale, page: $page, per: $per) {
      collection {
        ...ProfessionFragment
      }
    }
  }
  ${PROFESSION_FRAGMENT}
`;

export type ProfessionsData = {
  professions: { collection: ProfessionFragment[] };
};

export default (
  options?: LazyQueryHookOptions<ProfessionsData, ProfessionQueryVariables>
) => {
  return useLazyQuery<ProfessionsData, ProfessionQueryVariables>(
    GET_PROFESSIONS,
    options
  );
};
